module.exports = __webpack_public_path__ + "img/flower_leaf_34.2e20d34d.png";